<div class="container my-4" >

   <!-- Case: No Data -->
   <div *ngIf="!hierarchy || !hierarchy.accounts?.length" class="text-center py-5">
    <h5 class="text-muted">No data available</h5>
    <button class="btn btn-primary mt-3" (click)="goToLinkRoute('hr-dashboard')">
      <i class="bi bi-arrow-left"></i> Go to Dashboard
    </button>
  </div>

  <!-- Case: Data Available -->
  <div *ngIf="hierarchy && hierarchy.accounts?.length">

  <!-- Tenant Header -->
  <div class="card shadow-sm mb-4">
    <div class="card-body d-flex align-items-center justify-content-between">
      <h3 class="fw-bold mb-0">
        {{ hierarchy.name }}
      </h3>
      <span class="badge fs-5 px-3 py-2" [ngClass]="getBadgeClass(hierarchy.color)">
        {{ hierarchy.score }}%
      </span>
    </div>
  </div>

  

  <!-- Accounts -->
  <div *ngFor="let acc of hierarchy.accounts" class="tree-node">
    <div class="tree-connector"></div>
    <h5>
      <a (click)="toggleAccount(acc)"
         class="fw-semibold text-primary text-decoration-none" style="cursor: pointer;">
        <i class="bi bi-folder2-open me-1"></i>{{ acc.name }}
      </a>
      <span class="badge ms-2" [ngClass]="getBadgeClass(acc.color)">
        {{ acc.score }}%
      </span>
    </h5>

    <div *ngIf="acc.expanded" class="ms-4">
      <!-- Managers -->
      <div *ngFor="let mgr of acc.managers" class="tree-node mt-2">
        <div class="tree-connector"></div>
        <a (click)="toggleManager(acc, mgr)" 
           class="fw-normal text-secondary text-decoration-none" style="cursor: pointer;">
          <i class="bi bi-person-workspace me-1"></i>{{ mgr.name }}
        </a>
        <span class="badge ms-2" [ngClass]="getBadgeClass(mgr.color)">
          {{ mgr.score }}%
        </span>

        <div *ngIf="acc.selectedManager === mgr" class="ms-4 mt-2">
          <!-- Teams -->
          <div *ngFor="let team of mgr.teams" class="tree-node mt-2">
            <div class="tree-connector"></div>
            <a (click)="toggleTeam(team)"
               class="text-dark text-decoration-none" style="cursor: pointer;">
              <i class="bi bi-people me-1"></i>{{ team.name }}
            </a>
            <span class="badge ms-2" [ngClass]="getBadgeClass(team.color)">
              {{ team.score }}%
            </span>

            <div *ngIf="selectedTeam === team" class="ms-4 mt-2">
              <!-- Users -->
              <ul class="list-group list-group-flush mt-2">
                <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let user of team.users"
                  (click)="goToUserDetail(user.id)" style="cursor: pointer;">
                
                  <span>
                    <i class="bi bi-person-circle me-2"></i>{{ user.name }}
                  </span>
                
                  <span class="badge" [ngClass]="getBadgeClass(user.color)">
                    {{ user.score }}%
                  </span>
                </li>


              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
